import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import ButtonV2 from '@components/UI/ButtonV2';
import { useSelector } from '@hooks/redux';
import {EUserGroup, useGetUserSimulated} from './UserGroupSimulationLogic';
import {isPersonificationOn, useStopPersonificate} from "./UserGroupSimulation_PersonificateLogic"
import {UserGroup} from "@model/User"
import {setHideBannerWasClicked, setShowDialogUserGroupSimulationHide, setShowDialogUserGroupSimulationPage, setShowLabelPersonificationBanner} from "@redux-actions/";
import {USER_URLS} from "@components/link-utils";

type LabelPersonificationBannerProps = {
};

/**
 * Banner that is persistent in every page while simulating someone until is not dismissed or personification is not ended.
 * On dismiss show a UserGroupSimulationDialog.
 * Show if personification is on calling getUsersForSimulation API
 * @see DialogUserGroupSimulationPage
 * @see useGetUsersForSimilation
 * */
const LabelPersonificationBanner = (props: LabelPersonificationBannerProps) => {
	// let userSimulated = null
	// check if personification is on
	if(!isPersonificationOn()) return <></>
	// return <></>
	// check if actual page is /personification, so don't recall twice getUsersForSimulation API
	// if(!location.href.includes(USER_URLS.USER_GROUP_SIMULATION.URL)) userSimulated = useGetUserSimulated()
	// else userSimulated = useSelector(state=>state.utils.userSimulated)
	const userSimulated = useSelector(state=>state.utils.userSimulated)
	//useGetUserSimulated()
	const dispatch = useDispatch();
	const {stopPersonification} = useStopPersonificate()
	const lang = useSelector(state => state.utils.lang);
	const bShow: boolean = useSelector(state => state?.utils?.showLabelPersonificationBanner);
	const macroUserOfUserSimulated = userSimulated?.[EUserGroup.macroUser]
	const hideBannerWasClicked = useSelector(state => state.utils.hideBannerWasClicked)
	const [bShowSpinnerOnLogout, setShowSpinnerOnLogout] = useState<boolean>(false)

	const handleStopPersonificateClick = ()=>{
		if(userSimulated){
			setShowSpinnerOnLogout(true)
			stopPersonification()
		}
	}

	const onCloseDialogUserGroupSimulationPage = () => {
		dispatch(setHideBannerWasClicked(true))
		dispatch(setShowDialogUserGroupSimulationHide(true))
		// close itself
		dispatch(setShowLabelPersonificationBanner(false))
		dispatch(setShowDialogUserGroupSimulationPage(true))
	}

	if(!userSimulated || bShow == false || hideBannerWasClicked) return <></>

	return (
		<div className="label-personification-banner" id="label-personification-banner">
			<div className="label-personification-banner__container">
        <span>
          {lang?.PROFILE_PERSONIFICATION_LABEL_FIXED_BANNER_SIMULATON_ON} <span className='label-personification-banner__role'>{macroUserOfUserSimulated}</span>
        </span>

				<div className="label-personification-banner__ctas">
					<ButtonV2 className="label-personification-banner__ctas_hide"
					          handleClick={onCloseDialogUserGroupSimulationPage}>
											{lang?.PROFILE_PERSONIFICATION_LABEL_FIXED_BANNER_SIMULATON_CTA_HIDE}
					</ButtonV2>

					<ButtonV2 className="label-personification-banner__ctas_exit"
					          handleClick={handleStopPersonificateClick} loading={bShowSpinnerOnLogout} hideLoadingLabel>
											{lang?.PROFILE_PERSONIFICATION_TABLE_ACTION_EXIT}
					</ButtonV2>
				</div>
			</div>
		</div>
	)

}

export default LabelPersonificationBanner;

